import { ITranslations } from 'types/common';
import { DiscountTransFields } from './types';
import en from 'translations/en/discount.json';
import pl from 'translations/pl/discount.json';
import sl from 'translations/sl/discount.json';

export const discountTranslations: ITranslations<DiscountTransFields> = {
  name: 'discount',
  en,
  pl,
  sl,
};
